import { PropsWithChildren, Ref } from "react";
import { cn } from "@/common/utils/css.utils";
import { ProductDetailsPanelTitle } from "./ProductDetailsPanelTitle";

type ProductDetailsPanelProps = {
  title: string | JSX.Element;
  wrapperRef?: Ref<HTMLDivElement>;
  className?: string;
};

export const ProductDetailsPanel = ({
  title,
  wrapperRef,
  className,
  children,
}: PropsWithChildren<ProductDetailsPanelProps>) => {
  return (
    <div
      ref={wrapperRef}
      className={cn(
        "mx-auto flex w-full flex-col space-y-3.5 bg-white",
        className
      )}
    >
      <ProductDetailsPanelTitle>{title}</ProductDetailsPanelTitle>
      <div className="font-body">{children}</div>
    </div>
  );
};
